export const filterPanelStyles = {
    '& .MuiDataGrid-filterForm': {
        paddingBottom: '24px',
        gap: '16px',
    },
    '& .MuiDataGrid-filterForm >.MuiFormControl-root .MuiInputBase-root': {
        padding: '0 10px',
    },
};

export const dataGridRootStyles = {
    paddingTop: '10px',
};
